import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const useDebouncedInput = ({ initialValue = '', onChange = () => {} }) => {
  const [localValue, setLocalValue] = useState(initialValue);

  const debouncedOnChange = useCallback(debounce(onChange, 0), []);

  // needed to reconcile external onChange setters
  useEffect(() => {
    if (initialValue !== localValue) {
      // fixing race condition if overwriting the same value
      const handler = setTimeout(() => {
        setLocalValue(initialValue);
      }, 0);
      return () => {
        clearTimeout(handler);
      };
    }
  }, [initialValue]);

  return {
    localValue,
    setLocalValue,
    debouncedOnChange,
  };
};

export default useDebouncedInput;
